import { render, staticRenderFns } from "./AccessLockPage.vue?vue&type=template&id=2a2b719e"
import script from "./AccessLockPage.vue?vue&type=script&lang=ts"
export * from "./AccessLockPage.vue?vue&type=script&lang=ts"
import style0 from "./AccessLockPage.vue?vue&type=style&index=0&id=2a2b719e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports